export const antiPiracyMixin = {
  mounted() {
    this.addAntiPiracyListeners();
    this.injectAntiPiracyStyles();
  },
  beforeDestroy() {
    this.removeAntiPiracyListeners();
    this.removeAntiPiracyStyles();
  },
  methods: {
    preventEvent(e) {
      e.preventDefault();
      return false;
    },
    preventCopy(e) {
      e.preventDefault();
      if (e.clipboardData) {
        e.clipboardData.setData('text/plain', 'Este conteúdo é protegido por direitos autorais e não pode ser copiado.');
      }
      return false;
    },
    preventShortcuts(e) {
      // Prevenir Ctrl+P (Imprimir), Ctrl+S (Salvar), Ctrl+C (Copiar)
      if ((e.ctrlKey || e.metaKey) && (e.key === 'p' || e.key === 's' || e.key === 'c' || e.key === 'P' || e.key === 'S' || e.key === 'C')) {
        e.preventDefault();
        return false;
      }
      // Prevenir F12 e Ctrl+Shift+I (Inspecionar Elemento)
      if (e.key === 'F12' || ((e.ctrlKey || e.metaKey) && e.shiftKey && (e.key === 'i' || e.key === 'I'))) {
        e.preventDefault();
        return false;
      }
    },
    addAntiPiracyListeners() {
      document.addEventListener('contextmenu', this.preventEvent);
      document.addEventListener('copy', this.preventCopy);
      document.addEventListener('cut', this.preventCopy);
      document.addEventListener('dragstart', this.preventEvent);
      document.addEventListener('keydown', this.preventShortcuts);
    },
    removeAntiPiracyListeners() {
      document.removeEventListener('contextmenu', this.preventEvent);
      document.removeEventListener('copy', this.preventCopy);
      document.removeEventListener('cut', this.preventCopy);
      document.removeEventListener('dragstart', this.preventEvent);
      document.removeEventListener('keydown', this.preventShortcuts);
    },
    injectAntiPiracyStyles() {
      if (!document.getElementById('anti-piracy-styles')) {
        const style = document.createElement('style');
        style.id = 'anti-piracy-styles';
        style.innerHTML = `
          body {
            -webkit-user-select: none !important;
            -moz-user-select: none !important;
            -ms-user-select: none !important;
            user-select: none !important;
          }
          @media print {
            body {
              display: none !important;
            }
          }
        `;
        document.head.appendChild(style);
      }
    },
    removeAntiPiracyStyles() {
      const style = document.getElementById('anti-piracy-styles');
      if (style) {
        style.remove();
      }
    }
  }
};
